const AnalyticsFilledIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_13315_140092)">
        <path
          d="M12.5186 11.3047H19.4502C19.4763 11.3047 19.4966 11.3244 19.499 11.3496L19.4922 11.377L19.4893 11.417C19.3582 13.2523 18.6314 14.9209 17.499 16.2354L17.4795 16.2578L17.4629 16.2822C17.454 16.2954 17.4392 16.3046 17.4209 16.3047C17.4064 16.3047 17.3926 16.2984 17.3838 16.2891L17.3779 16.2822L12.4863 11.3906C12.4721 11.3766 12.4688 11.3634 12.4688 11.3545C12.4688 11.3278 12.4918 11.3047 12.5186 11.3047Z"
          fill="white"
          stroke="white"
        />
        <path
          d="M10.4189 1.34082C14.581 1.60943 17.9075 4.93756 18.1758 9.09766C18.1733 9.125 18.1521 9.14453 18.1279 9.14453H10.4229C10.3995 9.14451 10.375 9.12494 10.375 9.09277V1.38965C10.375 1.36553 10.393 1.34433 10.4189 1.34082Z"
          fill="white"
          stroke="white"
        />
        <path
          d="M8.27539 2.03809C8.30066 2.03963 8.32029 2.05925 8.32031 2.08496L8.32227 10.1123C8.32227 10.391 8.43066 10.6543 8.61914 10.8467L8.62305 10.8496L14.3027 16.5293V16.5303C14.313 16.5408 14.3183 16.5531 14.3184 16.5654C14.3184 16.5739 14.316 16.5807 14.3135 16.5859C14.3108 16.5914 14.3068 16.5963 14.3018 16.6006L14.2939 16.6074C12.8305 17.8871 10.9171 18.6621 8.82031 18.6621C4.22546 18.6621 0.5 14.935 0.5 10.3398C0.500125 5.92889 3.93427 2.31726 8.27539 2.03809Z"
          fill="white"
          stroke="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_13315_140092">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AnalyticsFilledIcon;
